import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background: white;\n\n  .ant-layout-content {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n  }\n\n  @media (min-width: 769px) and (max-width: 1200px) {\n    padding-bottom: ",
        ";\n\n    &:has(#library-lnb) > footer {\n      padding-left: ",
        "px;\n    }\n  }\n  //FIXME 디자인 시스템 적용시 제거\n\n  .gnb {\n    h1 {\n      .MuiBadge-badge {\n        display: none;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ExpertGNB from "@/components/common/GNB/ExpertGNB";
import GoodnotesGNB from "@/components/common/GNB/GoodnotesGNB";
import MarketGNB from "@/components/common/GNB/MarketGNB";
import { FooterView } from "@/containers/Layout/Footer/FooterView";
import { mobileTabBarHeight } from "@/containers/Layout/Header/MobileTabBar";
import { libraryLnbDimensions } from "@/modules/mypages/libraries/components/LibraryLNB";
import { ADMIN_PAGE_LOGIN, EBOOKS_UNIVERSITY_LANDING, MYPAGE_STORES_PRODUCTS_NEW_INDEX, PUBLISHER_LOGIN, VIEWER_PAGE, VIEWER_PRINTOUT_PAGE } from "@/settings/constant";
import { Layout } from "antd";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import * as React from "react";
import { useMemo } from "react";
import { isInWebview, useMounted } from "src/utils/misc";
import styled from "styled-components";
import SkeletonGNB from "@/components/common/GNB/SkeletonGNB";
const { Content  } = Layout;
const WebViewWrapper = styled.div.withConfig({
    componentId: "sc-a9f6f2ac-0"
})(_templateObject(), mobileTabBarHeight, libraryLnbDimensions.widthOnTablet + 40);
export const LayoutContainer = observer((param)=>{
    let { children  } = param;
    const router = useRouter();
    const { pathname , query  } = router;
    const { isUseFooter  } = useMemo(()=>({
            isUseFooter: !isInWebview()
        }), []);
    const withoutLayoutPages = [
        VIEWER_PRINTOUT_PAGE,
        VIEWER_PAGE,
        MYPAGE_STORES_PRODUCTS_NEW_INDEX,
        ADMIN_PAGE_LOGIN,
        PUBLISHER_LOGIN
    ];
    const isViewerPages = /\/viewer\//.test(pathname);
    const productEditPage = /\/products\/(.*)\/edit/.test(pathname);
    const goodNotesPage = pathname.includes(EBOOKS_UNIVERSITY_LANDING);
    const expertPage = pathname.includes("/expert");
    const mounted = useMounted();
    const renderGNB = useMemo(()=>{
        if (!mounted) return /*#__PURE__*/ _jsx(SkeletonGNB, {});
        if (goodNotesPage) return /*#__PURE__*/ _jsx(GoodnotesGNB, {});
        if (expertPage) return /*#__PURE__*/ _jsx(ExpertGNB, {});
        return /*#__PURE__*/ _jsx(MarketGNB, {});
    }, [
        mounted,
        pathname
    ]);
    if (withoutLayoutPages.includes(pathname) || isViewerPages || productEditPage) {
        return /*#__PURE__*/ _jsx(Content, {
            children: children
        });
    }
    return /*#__PURE__*/ _jsxs(WebViewWrapper, {
        children: [
            isUseFooter && renderGNB,
            /*#__PURE__*/ _jsx(Content, {
                children: children
            }),
            isUseFooter && /*#__PURE__*/ _jsx(FooterView, {})
        ]
    });
});
